import {
  ArtistNameSkeleton,
  ConfirmButtonSkeleton,
  SkeletonContainer,
} from './styled';

const InfoLoader = () => (
  <SkeletonContainer>
    <ArtistNameSkeleton variant="rectangular" />
    <ConfirmButtonSkeleton variant="rectangular" />
  </SkeletonContainer>
);

export default InfoLoader;
